<template>
  <div class="shipping-timeline">
    <h5>{{ _T('Shipping Details') }}</h5>
    <div class="steps-status">
      <div class="media">
        <div class="icon-status">
          <svg width="24" height="20" fill="none">
            <use xlink:href="#fork-knife" />
          </svg>
        </div>
        <div v-if="driverInformation && driverInformation.rider_data.event">
          <div
            class="media-body"
            v-if="driverInformation.rider_data.event === 'created'"
          >
            <h6>{{ _T('Order Status') }}</h6>
            <h4>{{ _T('Finding nearest driver') }}</h4>
          </div>
          <div class="media-body" v-else>
            <h6>{{ _T('Order Status') }}</h6>
            <h4 class="text-capitalize">
              {{ orderStatus(driverInformation.rider_data.event) }}
            </h4>
          </div>
        </div>
        <div v-else>
          <div class="media-body" v-if="!order_status">
            <h6>{{ _T('Waiting for order accept') }}</h6>
            <h4>{{ _T('Order placed') }}</h4>
          </div>
          <div class="media-body" v-else>
            <h6>{{ _T('Order Status') }}</h6>
            <h4 class="text-capitalize">
              {{ orderStatus(order_status.status) }}
            </h4>
          </div>
        </div>
      </div>
      <div class="media">
        <div class="icon-status">
          <svg width="24" height="24" fill="white">
            <use xlink:href="#store" />
          </svg>
        </div>
        <div class="media-body">
          <h6>{{ _T('Store address') }}</h6>
          <h4 v-if="this.$route.params && this.$route.params.store_id">
            <RestaurantAddress
              :address="find_store(this.$route.params.store_id)"
            />
          </h4>
          <h4 v-else>{{ _T('Loading') }}...</h4>
        </div>
      </div>
      <div class="media" v-if="order_type === CONST.ORDER_TYPE_ONLINE">
        <div class="icon-status">
          <svg width="26" height="26" fill="none">
            <use xlink:href="#user" />
          </svg>
        </div>
        <div class="media-body" v-if="address">
          <h6>{{ _T('Delivery Address') }}</h6>
          <h4>
            <CustomerAddress :address="address" filterAddress="true" />
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CustomerAddress from '../Util/CustomerAddresses'
import RestaurantAddress from '../Util/RestaurantAddress'
export default {
  components: { CustomerAddress, RestaurantAddress },
  computed: {
    ...mapGetters([
      '_T',
      'customer_address',
      'orderStatus',
      'find_store_by_main_id',
      'selected_order',
      'make_slug_to_data',
      'order_type',
      'currentStore',
    ]),
    ...mapState({
      placed_order: (state) => state.cart_store.order,
      order_status: (state) => state.tracking_store.order_status,
      driverInformation: (state) => state.tracking_store.driverInformation,
      order_id: (state) => state.tracking_store.order_id,
    }),
    /*storeAddress() {
      // return this.storeAddress(this.$route.params.store_id)
      console.log(this.placed_order, 'store_address')
      if (this.placed_order && this.placed_order.store_id) return this.store_address(this.placed_order.store_id)
      else return this.store_address(this.$route.params.store_id)
    },*/
    address() {
      if (this.customer_address) return this.customer_address
      if (this.placed_order) {
        return {
          flat_number: this.placed_order.order_flat_number,
          building: this.placed_order.order_building,
          street: this.placed_order.order_street,
          city: this.placed_order.order_city,
        }
      }
      return false
    },
    // ...mapState(['order'])
  },
  data() {
    return {
      interval: null,
      // orderId: this.selected_order.id || this.$route.params.order_id
    }
  },
  methods: {
    find_store(store_id) {
      let store = this.make_slug_to_data('store', store_id)
      if (!store) return this.find_store_by_main_id(store_id)
      else return this.find_store_by_main_id(store._id)
    },
    trackOrder() {
      this.$store.dispatch('orderTracking', this.$route.params.order_id, {
        root: true,
      })
    },
  },
  beforeMount() {
    // because of reload it should show instent it will work only on tracking page
    let orderId = this.$route.params.order_id
    if (orderId) this.trackOrder()
  },
  mounted() {
    let orderId = this.$route.params.order_id
    this.interval = setInterval(() => {
      if (orderId) this.trackOrder()
    }, 1000 * 100)
  },
  destroyed() {
    clearInterval(this.interval)
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .media-body {
    //flex: unset;
    text-align: right;
  }
  .shipping-timeline {
    .steps-status {
      &::after {
        right: $px23;
        left: unset;
      }
      .media {
        .icon-status {
          margin-left: 20px;
        }
      }
    }
    h5 {
      text-align: right;
    }
  }
}
.shipping-timeline {
  padding: calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
    calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
    calc(#{$px30} + (77 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
  .steps-status {
    position: relative;
    &::after {
      position: absolute;
      content: '';
      top: 0;
      left: $px23;
      border: $px1 dashed $light-font;
      height: $px135; //px200px
    }
    .media {
      + .media {
        padding-top: calc(
          #{$px24} + (42 - 24) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      &:nth-child(2) {
        .icon-status {
          background-color: $warning-color;
          border: $px4 solid $warning-color, 30%;
          padding-left: $px2;
        }
      }
      &:nth-child(3) {
        .icon-status {
          background-color: $color-tertiary;
          border: $px4 solid $tertiary-light;
          padding-left: $px2;
        }
      }
      .icon-status {
        width: $px50;
        height: $px50;
        background-color: $color-primary;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: $px4 solid hsl(351, 70%, 60%);
        z-index: 2;
      }
      .media-body {
        margin-left: calc(
          #{$px10} + (17 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
        h4 {
          margin-bottom: 0;
          font-weight: 600;
        }
        h6 {
          margin-bottom: $px2;
          line-height: $px22;
          letter-spacing: 0.5px;
        }
      }
    }
  }
  h5 {
    font-weight: 600;
    margin-bottom: calc(
      #{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320))
    );
  }
}
@media (max-width: 575px) {
  .shipping-timeline {
    margin-bottom: $px90;
    .steps-status {
      .media {
        .icon-status {
          width: $px40;
          height: $px40;
          img {
            width: 55%;
          }
        }
        .media-body {
          h4 {
            font-size: $px14 !important;
          }
        }
      }
      &::after {
        display: none;
      }
    }
  }
}
</style>
